import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import * as _ from 'lodash'
import { LearnerService } from 'src/app/services/learner.service';
import { QuizService } from 'src/app/services/quiz.service';
import { Observable } from 'rxjs';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ConfirmStatusComponent } from './confirm-status/confirm-status.component';
import { CourseUnitsService } from '../../services/course-units.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserRoleService } from '../../services/user-role.service';

@Component({
  selector: 'app-portfolio-status',
  templateUrl: './portfolio-status.component.html',
  styleUrls: ['./portfolio-status.component.scss']
})
export class PortfolioStatusComponent implements OnInit {

  @Input('job') job;
  course: any;
  headers;
  isMp
  learners: [];
  tooltip: any;
  allLearners: any;
  hoverIndex: any;
  selectedLearners;
  learnersCopy: any;
  sessionLength;
  loading: boolean = false;
  jobId
  isLearner
  isTrainer
  isIQA
  isAdmin
  isClient
  noDataMsg = {
    title: "No Learners!",
    data: "You have not added any learners yet."
  }
  learnersForStatus = [];
  removeSelectedOnClose = [];
  // status: any;
  user: any;


  private learnerRemove: Subject<any> = new Subject<any>();
  private addLearnerSubscription: Subject<any> = new Subject<any>();

  constructor(public _portfolioService: PortfolioService, public activatedRoute: ActivatedRoute, public dialog: MatDialog, public _snackBar: MatSnackBar,
    public _learnerService: LearnerService, public _userRoleService: UserRoleService, public router: Router, public _quizService: QuizService, public courseUnitService: CourseUnitsService) {

    this._learnerService.newLearnerObservable()
      .pipe(
        takeUntil(this.addLearnerSubscription)
      )
      .subscribe((newLeaner) => {
        console.log("new learner called in portfolio-status compoennt", newLeaner);
        if (newLeaner && newLeaner.learner) {
          // this.getTitles()
          // this.getLearnersStatus()
          this.getLearnersStatus()
          this.getUnitsOfCourse()
        }
        // this.learners = newLeaner.learner
        // this.learnersCopy = newLeaner.learner
      })


    this._learnerService.removeLearnerObservable()
      .pipe(
        takeUntil(this.learnerRemove)
      )
      .subscribe((learner) => {
        console.log("when learner remove from job", learner);

        if (learner) {
          this.getLearnersStatus()
          this.getUnitsOfCourse()
        }
      })


  }


  ngOnDestroy() {
    this.learnerRemove.next();
    this.learnerRemove.complete();
    this.addLearnerSubscription.next();
    this.addLearnerSubscription.complete();

    console.log("this.learnerRemove!!!", (!this.learnerRemove.closed))
  }



  ngOnInit() {

    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("what is the user role value", this.user);

    this.loading = true
    // this.activatedRoute.params.subscribe(param=>{
    //   this.jobId = param.jobid
    // })
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("job in the portlofio component", changes);
    if (changes.job) {
      this.loading = true
      this.job = changes.job.currentValue
      this.course = this.job.course
      this.jobId = this.job._id
      // this.getTitles()
      this.getLearnersStatus()
      this.getUnitsOfCourse()
      this.getUserRole()
      // this.getLearners()
      // this.getLearnersFromQuiz()
    }
  }

  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.job.instructors, 'job');
    console.log("getRole", getRole);

    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isClient) this.isClient = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isMp) this.isMp = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true

  }

  checkStatus(submission, session) {
    // console.log("submission", submission, "session", session);
    let index = _.findIndex(submission, function (o) {
      // if(o.assessment){
      // if(o.quizId && o.quizId.sessionId){
      return o.courseFolder == session._id;
      // }
      // }
      // else{
      //   this.tooltip = 'Pending'
      //   return 'Pending'
      // }
    })
    if (index > -1) {
      // console.log("%c MATCH FOUND HERE", "color:blue", submission[index].assessment.status);
      if (submission[index]) {
        this.tooltip = submission[index].status

        return submission[index].status
      } else {
        this.tooltip = 'Pending';

        return 'Pending';
      }
    } else {
      this.tooltip = 'Pending';

      return 'Pending';
    }
  }

  learnerIndex(i) {
    this.hoverIndex = i
  }
  learnerIndexChanged(i) {
    this.hoverIndex = -1
  }

  getFilteredData() {
    console.log(this.selectedLearners);
    if (this.selectedLearners && this.selectedLearners.length) {
      this.learners = this.selectedLearners
    }
    else {
      this.learners = this.learnersCopy
    }
    // let tempLearners = []
    // this.selectedLearners.forEach(learner=>{

    // })
  }
  redirection(learner, session) {
    console.log("learner", learner, "session", session)
    this.router.navigate(['/learnerAllotment/' + session.sessionId], { queryParams: { courseType: 'Level2', sessionType: session.sessionType, learnerId: learner.userId } })
  }
  changeStatus(learner, session, learnIndex, submissionIndex, event) {
    console.log("event of status change by client", event.target.value);

    let temp = {
      session: session,
      learner: learner
    }
    this.removeSelectedOnClose.push(temp)
    console.log(this.removeSelectedOnClose)
    console.log("event", event, typeof event.target.classList[event.target.classList.length - 1]);
    let lastClass = event.target.classList[event.target.classList.length - 1]

    if (lastClass != 'selected') {
      console.log("lastClass value", $("#Pending" + session._id + learner.userId));
      // $("#Pending" + session.sessionId + learner.userId).removeClass('Unassigned');
      $("#Pending" + session._id + learner.userId).addClass('selected');
    }
    else {
      console.log("%c IN second if", "color:red", lastClass)
      $("#Pending" + session._id + learner.userId).removeClass('selected');
      // $("#Pending" + session.sessionId + learner.userId).addClass('Unassigned');
    }


    console.log("Learner choosen is", learner, session)
    let obj = {
      learnerId: learner.userId,
      // sessionId: session._id,
      courseFolder: session._id,
      // sessionType: 'classroomsession',
      jobId: this.job._id,
      courseId: this.course._id,
      status: 'Completed',
      unitNo: session.unitNo,
      name: learner.name
    }

    if (learner.submissions) {
      let unitStatusIndex = _.findIndex(learner.submissions, function (o) { return o.courseFolder == session._id })
      if (unitStatusIndex > -1) {
        obj['_id'] = learner.submissions[unitStatusIndex]._id
      }
    }

    let index = _.findIndex(this.learnersForStatus, function (o) { return o.learnerId == learner.userId })
    if (index > -1) {
      console.log("this.learnersForStatus[index]", this.learnersForStatus[index])
      if (this.learnersForStatus[index].sessionId == session._id) {
        console.log('IN SECOND IF')
        this.learnersForStatus.splice(index, 1)
      }
      else {
        this.learnersForStatus.push(obj)
      }
      // this.learnersForStatus.splice(index, 1)
    } else {
      this.learnersForStatus.push(obj)
    }
    console.log("this.learnersForStatus", this.learnersForStatus)

  }

  changeCompletedStatus(learner, session, learnIndex, submissionIndex, event) {
    console.log("event of status change by client", event.target.value);

    let temp = {
      session: session,
      learner: learner
    }
    this.removeSelectedOnClose.push(temp)
    console.log(this.removeSelectedOnClose)
    console.log("event", event, typeof event.target.classList[event.target.classList.length - 1]);
    let lastClass = event.target.classList[event.target.classList.length - 1]
    if (lastClass != 'selected') {
      // $("#Pending" + session.sessionId + learner.userId).removeClass('Unassigned');
      $("#Completed" + session._id + learner.userId).addClass('selected');
    }
    else {
      console.log("%c IN second if", "color:red", lastClass == 'selected')
      $("#Completed" + session._id + learner.userId).removeClass('selected');
      // $("#Pending" + session.sessionId + learner.userId).addClass('Unassigned');
    }


    console.log("Learner choosen is", learner, session)
    let obj = {
      learnerId: learner.userId,
      // sessionId: session._id,
      courseFolder: session._id,
      // sessionType: 'classroomsession',
      jobId: this.job._id,
      courseId: this.course._id,
      status: 'Pending',
      unitNo: session.unitNo,
      name: learner.name
    }

    if (learner.submissions) {
      let unitStatusIndex = _.findIndex(learner.submissions, function (o) { return o.courseFolder == session._id })
      if (unitStatusIndex > -1) {
        obj['_id'] = learner.submissions[unitStatusIndex]._id
      }
    }

    let index = _.findIndex(this.learnersForStatus, function (o) { return o.learnerId == learner.userId })
    if (index > -1) {
      console.log("this.learnersForStatus[index]", this.learnersForStatus[index])
      if (this.learnersForStatus[index].sessionId == session._id) {
        console.log('IN SECOND IF')
        this.learnersForStatus.splice(index, 1)
      }
      else {
        this.learnersForStatus.push(obj)
      }
      // this.learnersForStatus.splice(index, 1)
    } else {
      this.learnersForStatus.push(obj)
    }
    console.log("this.learnersForStatus", this.learnersForStatus)
  }

  status() {
    this.openDialog(ConfirmStatusComponent, this.learnersForStatus).subscribe(updatedLearners => {
      if (!updatedLearners) return
      if (updatedLearners.type == 'yes') {
        this.learnersForStatus = []
        this.learners = updatedLearners.data
        this.learnersCopy = updatedLearners.data
        this.openSnackBar('Status Updated Successfully', 'OK')
        this.getLearnersStatus()
      }
      else {
        if (this.removeSelectedOnClose.length) {
          this.removeSelectedOnClose.forEach(singleItem => {
            $("#Pending" + singleItem.session.sessionId + singleItem.learner.userId).removeClass('selected');
            $("#Pending" + singleItem.session.sessionId + singleItem.learner.userId).addClass('Pending');


            $("#Completed" + singleItem.session.sessionId + singleItem.learner.userId).removeClass('selected');
            $("#Completed" + singleItem.session.sessionId + singleItem.learner.userId).addClass('Completed');
          })

        }
        this.learnersForStatus = []
        this.removeSelectedOnClose = []
      }

    })
  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  getTitles() {

    this._portfolioService.getClassromGroupedByCourseId(this.course._id).subscribe(res => {
      console.log('classroom grouped portfolio', res);
      // this.headers = res
      this.sessionLength = res.length

    })
  }

  getLearners() {
    this.loading = true
    this._portfolioService.getClassromGroupedByJobId(this.job._id).subscribe(res => {
      console.log('classroom grouped portfolio only learner name', res);
      this.learners = res
      this.learnersCopy = res
      this.loading = false;
    })
  }

  getLearnersStatus() {
    this.loading = true
    this._portfolioService.getStatusGroupedByJobId(this.job._id).subscribe(res => {
      console.log('classroom grouped portfolio', res);
      this.learners = res
      this.learnersCopy = res
      this.loading = false;
    })
  }


  getLearnersFromQuiz() {
    this._quizService.getLearnersWithStatus(this.job._id).subscribe(res => {
      console.log("QUIZ RESPONSE IN COMPONENT", res)
      this.learners = res.data.data;
      this.learnersCopy = res.data.data;
      this.loading = false;
    })
  }



  getUnitsOfCourse() {
    let courseId = this.job.course._id
    this.courseUnitService.getUnits(courseId).subscribe(res => {
      console.log("response of all status", res);
      let obj = {
        title: 'Track Maintenance'
      }
      let found = false;
      for (let i = 0; i < res.length; i++) {
        if (res[i].title == 'Track Maintenance' || res[i].title == 'Technical Certificate') {
          found = true;
          break;
        }
      }


      console.log("what is the checked value", found);

      if (found) {
        let unitArray = []
        let newArray = res.filter((o) => {
          if (o.title == 'Track Maintenance' || o.title == 'Technical Certificate') {
            unitArray.push(o)
          }
        })
        console.log("display unit array", unitArray);
        let finalArray = []

        unitArray.forEach((item) => {
          let obj = {
            _id: item.title,
            session: []
          }

          let index = finalArray.findIndex(x => x._id === item.title);
          if (index > -1) {
            finalArray[index].session.push(item)
          } else {
            obj.session.push(item)
            finalArray.push(obj)
          }
        })
        this.headers = finalArray
        console.log("output of display array", this.headers);
      } else {
        console.log("this is for new development", res);
        let finalArray = []
        res.forEach((item) => {
          let obj = {
            _id: item.title,
            session: []
          }
          if (item && item.unitNo != null) {
            let index = finalArray.findIndex(x => x._id === item.title);
            if (index > -1) {
              finalArray[index].session.push(item)
            } else {
              obj.session.push(item)
              finalArray.push(obj)
            }
          }
        })
        console.log("this is the final array to be print", finalArray);
        this.headers = finalArray
      }
    })
  }

}
